/**
 * SXVideoSequence Creator
 *
 * @note 有两种方式, 创建视频序列
 *
 * 1. 如果已知序列视频的所有信息, 以下 defaults 中的选项(width, height, fps, rotation)填写的,
 *      此时尽管序列中的视频文件一个没有下载,也能创建一个有效的 VideoSequence
 * 2. 如果不知道序列视频的信息, 必须把第一个片段视频文件下载到本地供  SXResource 初始化的时候读取视频的信息
 *
 */

 export default function SXVideoSequence(sequenceJson) {
    // SXVideoSequenceJson
    var sequenceJsonDefaults = {
        width: 0,
        height: 0,
        fps: 0,
        rotation: 0,
        sample_rate: 0,
        channels: 0,
        list: []
    };
    this.sequenceJson = Object.assign({}, sequenceJsonDefaults, sequenceJson);
}


SXVideoSequence.prototype.parseM3U8Content = function( url, m3u8_content, prefix) {
    var _this = this;
    var m3u8 = m3u8_content;
    var isMasterPlaylist = m3u8.indexOf("#EXT-X-STREAM-INF") >= 0;
    var lines = m3u8.trim().replace(/(\r\n|\r|\n)+/g, "\n").split("\n"); // line break normalize
    var list = null;
    if (lines[0].trim() === "#EXTM3U") {
        isMasterPlaylist ? list = _parseMasterPlaylist(lines, url) // { url, type, version, streams }
            : list = _parseMediaPlaylist(lines, url); // { url, type, version, mediaSegments, ... }
    }

    let data = list;

    let start = 0;
    for (var i = 0; i < data.mediaSegments.length; i++) {
        let fileName = data.mediaSegments[i].tsURL.substring(data.mediaSegments[i].tsURL.lastIndexOf("/"));

        _this.sequenceJson.list.push({
            duration: data.mediaSegments[i].tsDuration,
            localStart : start,
            localEnd : start + data.mediaSegments[i].tsDuration,
            url: data.mediaSegments[i].tsURL,
            path: prefix + _this.uuid()  +fileName,
            status: 0
        });
        start += data.mediaSegments[i].tsDuration;
    }

    return _this.sequenceJson;
}

/**
 * 从 m3u8 链接获取 VideoSequence
 *
 * @param url m3u8 链接
 * @param prefix 本地保存文件的目录, 使用 / 结尾
 *
*/
SXVideoSequence.prototype.fromM3U8Url = function (url, prefix) {
    var _this = this;
    this.url = url;
    this.isLoading = true;
    this.playList = {};
    // 1. get url
    // 2. parse
    // 3. return SXVideoSequenceJson
    var ret = getM3U8Content(url).then(function (data) {
        if (data.code == -1) {
            return null;
        }
        var m3u8 = data.content;
        var isMasterPlaylist = m3u8.indexOf("#EXT-X-STREAM-INF") >= 0;
        var lines = m3u8.trim().replace(/(\r\n|\r|\n)+/g, "\n").split("\n"); // line break normalize
        var list = null;
        if (lines[0].trim() === "#EXTM3U") {
            isMasterPlaylist ? list = _parseMasterPlaylist(lines, url) // { url, type, version, streams }
                : list = _parseMediaPlaylist(lines, url); // { url, type, version, mediaSegments, ... }
        }
        return list;
    }).then(function (data) {
        let start = 0;
        for (var i = 0; i < data.mediaSegments.length; i++) {
            let fileName = data.mediaSegments[i].tsURL.substring(data.mediaSegments[i].tsURL.lastIndexOf("/"));

            _this.sequenceJson.list.push({
                duration: data.mediaSegments[i].tsDuration,
                localStart : start,
                localEnd : start + data.mediaSegments[i].tsDuration,
                url: data.mediaSegments[i].tsURL,
                path: prefix + _this.uuid()  +fileName,
                status: 0
            });
            start += data.mediaSegments[i].tsDuration;
        }
        return _this.sequenceJson;
    });
    return ret;
};


function _getBaseUrl(url) {
    var lastIndex = url.lastIndexOf("/");
    var subUrl = url.substring(0, lastIndex);
    return subUrl;
}
function _isAbsoluteUrl(url) {
    if (url.indexOf("http://") > -1 || url.indexOf("https://") > -1) {
        return true;
    }
    return false;
}
function _toAbsoluteURL(url, baseURL) {
    if (!baseURL || _isAbsoluteUrl(url)) {
        return url;
    }
    return _getBaseUrl(baseURL) + "/" + url;
}

// function M3U8_trim(playlist, // @arg MediaPlaylistObject
// options) {
//     // @options.startTime UINT32 = 0
//     // @options.maxLength UINT8 = 0
//     // @ret MediaPlaylistObject
//     options = options || {};
//     return _trimMediaSegments(playlist, options["startTime"] || 0, options["maxLength"] || 0);
// }

function _parseMasterPlaylist(lines, // @arg LineStringArray - ["#EXTM3U", "#EXT-X-VERSION:3", ...]
url) {
    // @ret MasterPlaylistObject
    var masterPlaylistObject = {
        "url": url,
        "type": "MASTER",
        "version": 0,
        "streams": [], // MasterStreamObjectArray: [{ url, info, codecs, bandwidth, resolution, video, audio }, ...]
    };
    var itemInfo = null;
    for (var i = 0, iz = lines.length; i < iz; ++i) {
        var line = lines[i].trim();
        if (line) {
            if (/^#EXT/.test(line)) { // The Tag-line (^#EXT...)
                var record = line.split(":"); // "key:value" -> [key, value]
                var key = record[0];
                var value = record[1];
                switch (key) {
                    case "#EXT-X-VERSION":
                        masterPlaylistObject["version"] = parseFloat(value);
                        break;
                    case "#EXT-X-STREAM-INF": itemInfo = _parseMasterStreamInfo(value);
                }
            }
            else if (/^#/.test(line)) { // The Comment-line (^#...)
                // skip
            }
            else if (itemInfo) {
                // var codecs = _parseCodec(itemInfo["CODECS"] || "");
                masterPlaylistObject["streams"].push({
                    "url": _toAbsoluteURL(line, url),
                    "info": itemInfo["info"].trim(),
                    "codecs": itemInfo["CODECS"] || "",
                    "bandwidth": parseInt(itemInfo["BANDWIDTH"] || "") || 0,
                    "resolution": itemInfo["RESOLUTION"] || "",
                    // "video": {
                    //     "codec": codecs.video.codec,
                    //     "profile": codecs.video.profile,
                    //     "profileID": codecs.video.profileID,
                    //     "level": codecs.video.level,
                    // },
                    // "audio": {
                    //     "codec": codecs.audio.codec,
                    //     "profile": codecs.audio.profile,
                    //     "objectType": codecs.audio.objectType,
                    // },
                });
                itemInfo = null; // reset
            }
        }
    }
    return masterPlaylistObject;
}
function _parseMediaPlaylist(lines, // @arg LineStringArray - ["#EXTM3U", "#EXT-X-VERSION:3", ...]
url) {
    // @ret MediaPlaylistObject
    var mediaPlaylistObject = {
        "url": url,
        "type": "LIVE",
        "version": 0,
        "combined": false,
        "allowCache": false,
        "mediaSequence": 0,
        "mediaSegments": [],
        "targetDuration": 0,
        "totalDurations": 0, // sum of the segment durations (VOD only) UINT32 (msec value)
    };
    var tsTitle = "";
    var tsDuration = 0; // msec
    var totalDurations = 0; // msec
    for (var i = 0, iz = lines.length; i < iz; ++i) {
        var line = lines[i].trim();
        if (line) {
            if (/^#EXT/.test(line)) { // The Tag-line (^#EXT...)
                var record = line.split(":"); // "key:value" -> [key, value]
                var key = record[0];
                var value = record[1];
                switch (key) {
                    case "#EXT-X-VERSION":
                        mediaPlaylistObject["version"] = parseFloat(value);
                        break;
                    case "#EXT-X-ENDLIST":
                        mediaPlaylistObject["type"] = "VOD";
                        break;
                    case "#EXT-X-COMBINED":
                        mediaPlaylistObject["combined"] = value === "YES";
                        break;
                    case "#EXT-X-ALLOW-CACHE":
                        mediaPlaylistObject["allowCache"] = value === "YES";
                        break;
                    case "#EXT-X-TARGETDURATION":
                        mediaPlaylistObject["targetDuration"] = (parseFloat(value)) | 0;
                        break;
                    case "#EXT-X-MEDIA-SEQUENCE":
                        mediaPlaylistObject["mediaSequence"] = parseInt(value);
                        break;
                    case "#EXT-X-DISCONTINUITY": break; // TODO:
                    case "#EXTINF":
                        tsDuration = parseFloat(value.split(",")[0]);
                        tsTitle = value.split(",").slice(1).join(","); // "duration,title..."
                }
            }
            else if (/^#/.test(line)) { // The Comment-line (^#...)
                // skip
            }
            else if (tsDuration) {
                mediaPlaylistObject["mediaSegments"].push({
                    "tsID": mediaPlaylistObject["mediaSequence"] + mediaPlaylistObject["mediaSegments"].length,
                    "tsURL": _toAbsoluteURL(line, url),
                    "tsDuration": tsDuration || 0,
                    "tsTitle": tsTitle || "",
                    "tsRange": {
                        "startTime": totalDurations,
                        "endTime": totalDurations + tsDuration
                    },
                });
                totalDurations += tsDuration;
                tsDuration = 0; // reset
                tsTitle = ""; // reset
            }
        }
    }
    if (mediaPlaylistObject["type"] === "VOD") {
        mediaPlaylistObject["totalDurations"] = totalDurations;
    }
    if (mediaPlaylistObject["type"] === "LIVE" &&
        mediaPlaylistObject["targetDuration"] <= 2000) {
        mediaPlaylistObject["type"] = "NRTLIVE";
    }
    return mediaPlaylistObject;
}
function _parseMasterStreamInfo(source) {
    // @ret Object - { BANDWIDTH: "710852", CODECS: "avc1.66.30,mp4a.40.2", RESOLUTION: "432x768", info: "BANDWIDTH=710852..." }
    // @desc parse "key=value,..." -> { key: value, ... }
    var result = { "info": source };
    var inQuote = false; // in "..."
    var inKey = true; // in key=value
    var key = "";
    var value = "";
    for (var i = 0, iz = source.length; i < iz; ++i) {
        var tokenEnd = (i === iz - 1) ? true : false;
        var c = source[i];
        if (inQuote) {
            switch (c) {
                case '"':
                    inQuote = false;
                    break;
                default: if (inKey) {
                    key += c;
                }
                else {
                    value += c;
                }
            }
        }
        else {
            switch (c) {
                case '"':
                    inQuote = true;
                    break;
                case '=':
                    if (inKey) {
                        inKey = false;
                    }
                    else {
                        value += c;
                    }
                    break;
                case ',':
                    if (inKey) {
                        key += c;
                    }
                    else {
                        tokenEnd = true;
                    }
                    break;
                default: if (inKey) {
                    key += c;
                }
                else {
                    value += c;
                }
            }
        }
        if (tokenEnd) {
            result[key] = value;
            inKey = true;
            key = "";
            value = "";
        }
    }
    return result;
}
// 下载 m3u8 内容
function getM3U8Content(url) {
    var get = function (url) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = "text";
            xhr.onreadystatechange = function () {
                if (this.readyState === 4) {
                    if (this.status === 200) {
                        var resJson = { code: 0, content: this.response };
                        resolve(resJson, this);
                    }
                    else {
                        var resJson = { code: -1, content: this.response };
                        reject(resJson, this);
                    }
                }
            };
            xhr.send();
        });
    };
    return get(url);
}
SXVideoSequence.prototype.uuid = function () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
};
SXVideoSequence.prototype.extname = function (filename) {
    if (!filename || typeof filename != 'string') {
        return "";
    }
    ;
    var a = filename.split('').reverse().join('');
    var b = a.substring(0, a.search(/\./)).split('').reverse().join('');
    return b;
};


// module.exports = SXVideoSequence;